export default __webpack_public_path__ + "static/media/eyeclosed-icon.61162e65.svg";